module.exports = __webpack_public_path__ + "static/media/employeeDirectory.99243e7f.png";